module.exports = __webpack_public_path__ + "media/images/attribution_icon-9860ff24db035683399229da8f8f337d.svg";